import {
    CatalogApiObject,
    useFormaliteService,
    useFormulaireService,
} from '@europrocurement/l2d-domain';
import { useSelectedDossierContext } from '@europrocurement/l2d-modules';
import { getPrestationsPayload } from '@europrocurement/l2d-modules/modules/ParcoursFormalite/provider/functions';

const useAddFormality = () => {
    const { dossier } = useSelectedDossierContext();
    const { prestationFormaliteApi } = useFormaliteService();
    const { formulairesApi } = useFormulaireService();

    const addFormality = async (catalogs: CatalogApiObject[]) => {
        const payloads = await getPrestationsPayload(catalogs, formulairesApi);

        const promises = payloads.map((payload) =>
            prestationFormaliteApi.apiPrestationsPost({
                prestationJsonldPrestationCreate: {
                    dossier: dossier.id as unknown as string,
                    ...payload,
                },
            }),
        );

        return Promise.all([promises]);
    };

    return { addFormality };
};

export default useAddFormality;
